import React from 'react';
import { dateWordShort } from 'helper/helper';
import { Building, PersonIcon, Calendar } from 'assets/icons';
import MobileListCard from './MobileListCard';

const TimeSheetMobileCard = ({ item, onClick, isSelected }) => {
  const periode = item.periode_start && item.periode_end
    ? `${dateWordShort(item.periode_start)} > ${dateWordShort(item.periode_end)}`
    : 'N/A';
  
  const interimaire = item.firstname && item.lastname
    ? `${item.firstname} ${item.lastname}`
    : 'N/A';

  // Badge avec le n° de relevé
  const numeroBadge = item.id_time_sheet ? (
    <span className="inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset bg-gray-50 text-gray-600 ring-gray-500/10">
      {item.id_time_sheet}
    </span>
  ) : null;

  // Construire les metaItems avec icônes pour afficher sur 2 lignes
  const metaItems = [];
  
  if (item.name_commercial) {
    metaItems.push({
      icon: <Building wh={16} color="#6B7280" />,
      label: '',
      value: item.name_commercial,
    });
  }
  
  if (interimaire !== 'N/A') {
    metaItems.push({
      icon: <PersonIcon wh={16} color="#6B7280" />,
      label: '',
      value: interimaire,
    });
  }
  
  if (periode !== 'N/A') {
    metaItems.push({
      icon: <Calendar wh={16} color="#6B7280" />,
      label: '',
      value: periode,
    });
  }

  return (
    <MobileListCard
      title={item.title || 'N/A'}
      onClick={() => onClick && onClick(item)}
      isSelected={isSelected}
      topRightBadge={numeroBadge}
      metaItems={metaItems}
      className="timesheet-mobile-card"
    />
  );
};

export default TimeSheetMobileCard;

